<template>
  <svg :width="size.width" :height="size.height" @mousemove="mousemove">
    <g class="links">
      <path
        v-for="l in sankey.links"
        :key="`${l.source.name}-${l.target.name}`"
        :d="sankeyLinkHorizontal(l)"
        :style="{
          fill: 'none',
          stroke: chroma(color(l.source.name)).luminance(0.75),
          strokeWidth: Math.max(1, l.width)
        }"
      ></path>
    </g>
    <g class="nodes">
      <g
        v-for="n in sankey.nodes"
        :key="n.name"
        :transform="`translate(${n.x0},${n.y0})`"
        class="node"
      >
        <rect :fill="color(n.index)" :width="n.x1 - n.x0" :height="n.y1 - n.y0">
          <title>{{ n.name }}</title>
        </rect>
        <text
          :class="
            n.targetLinks.length
              ? n.targetLinks[0].properties.statusClass
              : null
          "
          :x="n.x1 - n.x0"
          :y="(n.y1 - n.y0) / 2"
          @click="gotoMonitor(n)"
          @mouseenter="selectNode(n)"
          @mouseleave="unselectNode()"
        >
          <tspan :dx="5" :dy="-2">{{ n.name }}</tspan>
          <tspan
            :x="n.x1 - n.x0"
            :dx="5"
            :dy="5"
            text-anchor="start"
            alignment-baseline="hanging"
          >
            {{ n.value }} ({{
              numeral(
                n.targetLinks.length
                  ? n.value / n.targetLinks[0].source.value
                  : 1
              ).format("0.[0]%")
            }})
          </tspan>
        </text>
      </g>
    </g>
    <foreignObject
      v-if="selectedNode"
      class="svg-tooltip"
      :x="mousePos.x - 70"
      :y="mousePos.y - 70"
    >
      <div>
        FFNs únicos:
        {{
          selectedNode.targetLinks.length
            ? selectedNode.targetLinks[0].properties.ffnCount
            : selectedNode.sourceLinks[0].properties.ffnCount
        }}
      </div>
      <div>
        Tickets únicos:
        {{
          selectedNode.targetLinks.length
            ? selectedNode.targetLinks[0].properties.ticketNumberCount
            : selectedNode.sourceLinks[0].properties.ticketNumberCount
        }}
      </div>
    </foreignObject>
  </svg>
</template>
<style lang="scss" scoped>
@import "../../scss/variables";

svg {
  rect,
  path,
  text {
    transition: all 0.5s ease-out;
  }
  .nodes {
    text {
      font-size: 10px;
      cursor: pointer;
      &.danger {
        fill: $darkred;
      }
    }
  }
  .svg-tooltip {
    border: 1px solid;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 10px;
    width: 140px;
    height: 60px;
    font-size: 12px;
  }
}
</style>
<script>
// import * as d3 from "d3";
import chroma from "chroma-js";
import { scaleOrdinal, schemeTableau10 } from "d3";
import { sankey, sankeyLeft, sankeyLinkHorizontal } from "d3-sankey";
import numeral from "numeral";

export default {
  props: {
    data: {
      required: true,
      type: Object
    },
    size: {
      type: Object,
      default: () => ({
        width: 1110,
        height: 600
      })
    },
    monitorUrlParams: { required: false, type: Object, default: null }
  },
  data() {
    return {
      selectedNode: null,
      mousePos: { x: 0, y: 0 }
    };
  },
  computed: {
    margin() {
      return {
        top: 20,
        left: 0,
        right: 180,
        bottom: 0
      };
    },
    sankey() {
      return sankey()
        .nodeAlign(sankeyLeft)
        .nodeWidth(16)
        .nodePadding(24)
        .nodeId(d => d.name)
        .extent([
          [this.margin.left, this.margin.top],
          [
            this.size.width - this.margin.right,
            this.size.height - this.margin.top
          ]
        ])(this.data);
    },
    sankeyLinkHorizontal() {
      return sankeyLinkHorizontal();
    },
    color() {
      return scaleOrdinal(schemeTableau10);
    },
    chroma() {
      return chroma;
    },
    numeral() {
      return numeral;
    }
  },
  methods: {
    mousemove(event) {
      const boundingRect = this.$el.getBoundingClientRect();
      this.mousePos = {
        x: event.clientX - boundingRect.left,
        y: event.clientY - boundingRect.top
      };
    },
    selectNode(n) {
      this.selectedNode = n;
    },
    unselectNode() {
      this.selectedNode = null;
    },
    gotoMonitor(node) {
      const urlParams = new URLSearchParams({
        event: node.targetLinks[0].properties.event,
        eventResult: node.targetLinks[0].properties.eventResult,
        ...this.monitorUrlParams
      });

      window.open(`backend/monitor?${urlParams}`, "_blank");
    }
  }
};
</script>
